import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { RenmoneyLogo, FutureAfrica, AbiaLogo, CcInterior, PlaudeLogo, AbiaGovt } from "assets/website";
import {
  pricingPartner1,
  pricingPartner2,
  pricingPartner3,
  pricingPartner4,
  pricingPartner5,
} from "assets/images";

const partnerLogos = [
  { component: RenmoneyLogo, name: "Renmoney" },
  { component: FutureAfrica, name: "Future Africa" },
  { component: AbiaLogo, name: "Abia Leadership Academy" },
  { component: CcInterior, name: "CC Interiors" },
  { component: PlaudeLogo, name: "Plaude" },
  { component: AbiaGovt, name: "Abia Government" },
];

const pricingPartnerImages = [
  { src: pricingPartner1, name: "Partner 1" },
  { src: pricingPartner2, name: "Partner 2" },
  { src: pricingPartner3, name: "Partner 3" },
  { src: pricingPartner4, name: "Partner 4" },
  { src: pricingPartner5, name: "Partner 5" },
];

interface DesktopPartnersProps {
  onPricing?: boolean;
}

const DesktopPartners = ({ onPricing }: DesktopPartnersProps) => {
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const checkDesktop = () => setIsDesktop(window.innerWidth >= 768);
    checkDesktop();
    window.addEventListener("resize", checkDesktop);
    return () => window.removeEventListener("resize", checkDesktop);
  }, []);

  if (!isDesktop) return null;

  return (
    <section className={`py-12 md:py-16 ${onPricing ? "bg-[#EFF4FA]" : "bg-white/70"} overflow-hidden`}>
      <div className="container mx-auto px-4">
        {!onPricing && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-center text-[#475467] text-lg font-medium mb-8"
          >
            Trusted by forward-thinking teams.
          </motion.p>)}

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="flex flex-wrap items-center justify-center gap-10 lg:gap-12"
        >
          {
            // onPricing
            //   ? pricingPartnerImages.map((partner, index) => (
            //       <div
            //         key={index}
            //         className="flex items-center justify-center hover:grayscale-0 transition-all duration-300 flex-shrink-0"
            //       >
            //         <img
            //           src={partner.src}
            //           alt={partner.name}
            //           className="h-12 w-auto object-contain"
            //         />
            //       </div>
            //     ))
            //   : 
            partnerLogos.map((partner, index) => (
              <div
                key={index}
                className="flex items-center justify-center hover:grayscale-0 transition-all duration-300 flex-shrink-0"
              >
                <partner.component className="h-12 w-auto" />
              </div>
            ))
          }
        </motion.div>
      </div>
    </section>
  );
};

export { DesktopPartners };
